import { render, staticRenderFns } from "./ManageAddress.vue?vue&type=template&id=2180b2e3&scoped=true"
import script from "./ManageAddress.vue?vue&type=script&lang=js"
export * from "./ManageAddress.vue?vue&type=script&lang=js"
import style0 from "./ManageAddress.vue?vue&type=style&index=0&id=2180b2e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180b2e3",
  null
  
)

export default component.exports